export default __webpack_public_path__ + "static/turntable-37aa3d5c77b701359fdd0750652240b0.jpg";